import TextEditor, { getEditorProps, useEditorRef, usePlugins } from './text_editor';
export default TextEditor;
export { getEditorProps, useEditorRef, usePlugins };



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/index.js